import { render } from "./MyPage.vue?vue&type=template&id=3b97b471&scoped=true&ts=true"
import script from "./MyPage.vue?vue&type=script&lang=ts"
export * from "./MyPage.vue?vue&type=script&lang=ts"

import "./MyPage.vue?vue&type=style&index=0&id=3b97b471&lang=less&scoped=true"

import exportComponent from "D:\\code\\hyz-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b97b471"]])

export default __exports__